<template>
    <div id="wrapper_404"><b-img class="align-self-center" src="@/assets/404.png" fluid></b-img></div>
</template>

<script>
export default {
  name: 'not_found'
}
</script>

<style>

#wrapper_404{
  width: 100%;
  height: 100%;
  background: #5ab1b8;
  display: flex;
}

#wrapper_404 img{
  margin: auto;
}
</style>